module.exports = __webpack_public_path__ + "assets/img/our-approach.3358056a.jpg";